var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF0D0D",
  d: "M16.227 6.661c-2.75 3.764-9.123.5-11.873 4.264-.837-2.078-1.405-3.714-2.241-5.791 2.75-3.764 8.86-.941 11.61-4.705q1.257 3.117 2.504 6.232"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF0D0D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.313,
  d: "m1.365 3.686 5.23 13.03"
})));
export default SvgFlagFilled;